/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TEnum } from './TEnum';
import {
    instanceOfTEnum,
    TEnumFromJSON,
    TEnumFromJSONTyped,
    TEnumToJSON,
} from './TEnum';

/**
 * @type IdErrorResultDtoOfStringError
 * 
 * @export
 */
export type IdErrorResultDtoOfStringError = TEnum;


export function IdErrorResultDtoOfStringErrorFromJSON(json: any): IdErrorResultDtoOfStringError {
    return IdErrorResultDtoOfStringErrorFromJSONTyped(json, false);
}

export function IdErrorResultDtoOfStringErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdErrorResultDtoOfStringError {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TEnumFromJSONTyped(json, true) };
    return  TEnumFromJSONTyped(json, true);
}

export function IdErrorResultDtoOfStringErrorToJSON(value?: IdErrorResultDtoOfStringError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTEnum(value)) {
        return TEnumToJSON(value as TEnum);
    }

    return {};
}

/**
 * Check if a given object implements the IdErrorResultDtoOfStringError interface.
 */
export function instanceOfIdErrorResultDtoOfStringError(value: any): value is IdErrorResultDtoOfStringError {
    if (instanceOfTEnum(value)) return true;
    return false;
}

